/* This file is autogenerated, see readme.md for instructions */
import CheckSmallSvgIcon from '@bloomreach/banana-theme/icons/check-small.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const CheckSmallIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <CheckSmallSvgIcon />
    </Icon>
  );
});

CheckSmallIcon.displayName = 'CheckSmallIcon';

export default CheckSmallIcon;
